// extracted by mini-css-extract-plugin
export default {"publicInterviewsList":"Public_publicInterviewsList__9+3Tt","item":"Public_item__sgBlx","card":"Public_card__uTlwb","verticalView":"Public_verticalView__lxFSd"};